import { Navigate, Route, RouteProps } from "react-router";
import { useAuth } from "../../auth/contexts/AuthProvider";
import { useLocalStorage } from "../../core/hooks/useLocalStorage";

type PrivateRouteProps = {
  roles?: string[];
} & RouteProps;

const PrivateRoute = ({
  children,
  roles,
  ...routeProps
}: PrivateRouteProps) => {
  const { hasRole, userInfo } = useAuth();
	const [authKey, setAuthKey] = useLocalStorage<string>("authkey", "");
  if (userInfo) {
	  console.log("i am testing userInfo " + authKey); 
    if (!hasRole(roles)) {
      return <Navigate to={`/403`} />;
    }
    return <Route {...routeProps} />;
  } else {
	  console.log("i am testing userInfo " + authKey); 
    return <Navigate to={`/login`} />;
  }
};

export default PrivateRoute;
